// @intl project:microsite

import React from 'react'
import { Provider } from 'react-redux'

import { KEY_PREFIX } from 'redux-persist/constants'

import RootLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/RootLayout'
import { GenericError } from '@lyrahealth-inc/ui-core-crossplatform/src/pages/genericError/GenericError'

import store from '../../../../data/storeConfiguration/store'
import MicrositeIntlProvider from '../../../../features/microsite/MicrositeIntlProvider'
import { BASIC_INFO_FORM_PATH } from '../../../constants/registrationFormConstants'

const isRegistrationPath = (pathname: string) => {
  const registrationPaths = [BASIC_INFO_FORM_PATH]
  return registrationPaths.some((path) => pathname.includes(path))
}

function ErrorFallbackContent() {
  const handleReloadPress = () => {
    if (isRegistrationPath(window.location.pathname)) {
      // Use sessionStorage directly instead of dispatch: the Redux store may be unreliable
      // after a crash, and dispatch may not complete before the reload below.
      sessionStorage.removeItem(`${KEY_PREFIX}register`)
    }

    document.location.reload()
  }

  return <GenericError onReloadPress={handleReloadPress} />
}

export default function ErrorFallback() {
  return (
    <Provider store={store}>
      <MicrositeIntlProvider>
        <RootLayout>
          <ErrorFallbackContent />
        </RootLayout>
      </MicrositeIntlProvider>
    </Provider>
  )
}
